/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataCompare.tpl.html';

angular
  .module('chatter.metadataCompare', [])
  .constant('METADATA_COMPARE_BATCH_STATE', {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED'
  })
  /**
   * Controller for the chatter.metadatacompare template.
   */
  .controller(
    'ChatterMetadataCompareCtrl',
    function (
      $scope,
      httpBatch,
      $filter,
      batchUtils,
      progressFactory,
      metadataCompareBatch,
      CHATTER_SIZES,
      METADATA_COMPARE_BATCH_STATE
    ) {
      var origMetadataCompareState = metadataCompareBatch.state;

      if (origMetadataCompareState === METADATA_COMPARE_BATCH_STATE.FINISHED) {
        progressFactory.disableProgress();
      }

      /**
       * Utility function to set the scope vars for the batch metadataCompare
       */
      function setMetadataCompareBatchData(batch) {
        var METADATACompareDate = moment(batch.date),
          objectTotal = _.reduce(
            batch.typeCounts,
            function (memo, type) {
              return memo + type.diff + type.equal;
            },
            0
          ),
          stateText =
            batch.state === METADATA_COMPARE_BATCH_STATE.FINISHED
              ? $filter('i18n')('COMPLETED_LOWERCASE')
              : $filter('i18n')('STARTED');

        if (objectTotal === 1) {
          $scope.metadataCompareText = $filter('i18n')('BATCH_METADATA_COMPARE_DETAIL_DATE_SINGLE', [
            $filter('i18n')('COMPARE'),
            stateText,
            METADATACompareDate.format('MMM D[,] YYYY h:mm A')
          ]);
        } else {
          $scope.metadataCompareText = $filter('i18n')('BATCH_METADATA_COMPARE_DETAIL_DATE', [
            $filter('i18n')('COMPARE'),
            stateText,
            METADATACompareDate.format('MMM D[,] YYYY h:mm A'),
            objectTotal
          ]);
        }

        $scope.metadataCompareBatch = batch;
        $scope.batchUtils = batchUtils;
        $scope.METADATA_COMPARE_BATCH_STATE = METADATA_COMPARE_BATCH_STATE;
      }

      // Setup the scope values for the initial load of the controller
      setMetadataCompareBatchData(metadataCompareBatch);

      // Watches to resize the canvas app based on the current state of the backup.
      $scope.$watch('metadataCompareInProgress ', function () {
        if (!$scope.metadataCompareInProgress || metadataCompareBatch.state === METADATA_COMPARE_BATCH_STATE.FINISHED) {
          // if the original metadataCompareStatus was not Finished then load the batch.
          if (origMetadataCompareState !== METADATA_COMPARE_BATCH_STATE.FINISHED) {
            httpBatch.getBatch($scope.stateParams.batchId).then(function (batch) {
              setMetadataCompareBatchData(batch);
            });
          }
          if (!progressFactory.disabled) {
            progressFactory.disableProgress();
          }
        }
      });

      /**
       * Handler to show metadataCompare details page in app.
       */
      $scope.showMetadataCompareInApp = function () {
        // Use the chatter gotoApp function.
        $scope.gotoApp('?batchId=' + $scope.stateParams.batchId + '&page=metadataCompareDetails');
      };
    }
  );
